import React from 'react'

const Manual_admin_propinas = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
          Admin - Propinas
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          La guía explica cómo configurar las opciones de propinas en InvuPOS, permitiendo establecer propinas automáticas y manuales, personalizar porcentajes y garantizar su correcta aplicación en los pedidos. Facilita la gestión eficiente de propinas en distintos países.
        </p>
        <iframe
          src="https://scribehow.com/embed/Admin__Propinas__72dUphw_RAq0qE_41oE3Ng?as=scrollable"
          className="scribe-iframe-general-50"
          width="100%"
          height="8000"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_admin_propinas